import { render, staticRenderFns } from "./RosterContract.vue?vue&type=template&id=b3e6d42c"
import script from "./RosterContract.vue?vue&type=script&lang=js"
export * from "./RosterContract.vue?vue&type=script&lang=js"
import style0 from "./RosterContract.vue?vue&type=style&index=0&id=b3e6d42c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports